import { render, staticRenderFns } from "./SettlementKasbon.vue?vue&type=template&id=9ed0d3ce"
import script from "./SettlementKasbon.vue?vue&type=script&lang=js"
export * from "./SettlementKasbon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports